import React, { useState } from 'react';
import { Modal, Button, Accordion } from 'react-bootstrap';
import { getAssetCategories } from './floorPlanAssets';

function FloorPlanAssetLibrary({ show, onHide, onSelectAsset }) {
  const [activeCategory, setActiveCategory] = useState(null);
  const categories = getAssetCategories();

  return (
    <Modal show={show} onHide={onHide} size="sm" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title className="h6">
          <i className="bi bi-lamp me-2"></i>
          Furniture & Fixtures
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <Accordion
          activeKey={activeCategory}
          onSelect={(key) => setActiveCategory(key)}
        >
          {Object.entries(categories).map(([key, category]) => (
            <Accordion.Item key={key} eventKey={key}>
              <Accordion.Header>
                <i className={`bi ${category.icon} me-2`}></i>
                {category.label}
                <span className="badge bg-secondary ms-auto me-2">{category.items.length}</span>
              </Accordion.Header>
              <Accordion.Body className="p-2">
                <div className="d-flex flex-column gap-1">
                  {category.items.map((item) => (
                    <Button
                      key={item.id}
                      variant="outline-secondary"
                      size="sm"
                      className="d-flex align-items-center gap-2 text-start"
                      onClick={() => {
                        onSelectAsset(item);
                        onHide();
                      }}
                    >
                      <span
                        className="d-inline-block rounded"
                        style={{
                          width: 20, height: 14,
                          backgroundColor: item.color,
                          border: '1px solid #ccc',
                          flexShrink: 0,
                        }}
                      />
                      <span className="flex-grow-1">{item.name}</span>
                      <small className="text-muted">
                        {item.width}"×{item.depth}"
                      </small>
                    </Button>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Modal.Body>
    </Modal>
  );
}

export default React.memo(FloorPlanAssetLibrary);
